// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_10131","block":"_72","banner":"_8945","item":"_14872","media":"_13353","indicator":"_15729","icon":"_590","total":"_13862"};